// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2oMu4","ranges":"BmiRanges_ranges__3QdNb"};